import { useLPMutation } from '../lib/hooks/useLPMutation';
import type { ScoreBreakdownType } from '../lib/types/TeamBehavior';
import { NudgeType } from '../components/Nudge/enums/NudgeType';
import { useRequestClient } from '../lib/hooks/useRequestClient';
import { apiEndpoints } from '../lib/apiEndpoints/apiEndpoints';

type SendNudgeMutationParams = {
  behavior?: ScoreBreakdownType;
  type: NudgeType;
};

export const useSendNudgeMutation = () => {
  const kyInstance = useRequestClient();

  return useLPMutation<unknown, SendNudgeMutationParams>(async (variables) => {
    const baseUrl = apiEndpoints.getAPIEndpoint('root');
    if (!baseUrl) {
      throw new Error('endpoint "root" is not defined');
    }
    const behaviorValue = variables.behavior?.replace(/^./, (char) => char.toLowerCase());
    const typeValue = variables.type === NudgeType.CONGRATS ? 'success' : 'fail';
    const url = `${baseUrl}/nudges/behavior/${behaviorValue}/status/${typeValue}`;
    if (!kyInstance) {
      throw new Error('Missing RequestClientProvider');
    }

    return await kyInstance.get(url).json();
  });
};
